import { AddressTypes, IAddress } from './address'
import { formatString } from '@cbgms/base/utils/helpers'

export const formatAddressStreetThenHouseNumber = (address: Partial<IAddress>, type: AddressTypes) => {
  if (type === 'Visitor') {
    return formatString(
      address.VisitorAddress,
      address.VisitorAddressExtra,
      `${address.VisitorHouseNumber || ''}${address.VisitorHouseNumberAddition || ''}`
    )
  }

  return formatString(address.PostalAddress, address.PostalAddressExtra, `${address.PostalHouseNumber}${address.PostalHouseNumberAddition}`)
}
